import groupBy from "lodash.groupby";
import { composeInsights } from "../../../redux/modules/insights/utils";

type GroupFunction = (
  items: Insite.Insights.ComposedOccurrence[],
  uniqActionCount?: boolean
) => Insite.Insights.ComposedInsight[];

export const groupBySite: GroupFunction = (
  occurrences,
  uniqActionCount = false
) => {
  if (occurrences.length < 1) return [];
  return composeInsights(
    groupBy(occurrences, (o) => o.ruleId),
    uniqActionCount
  );
};

export const groupByPriority: GroupFunction = (
  occurrences,
  uniqActionCount = false
) => {
  if (occurrences.length < 1) return [];
  // NOTE: generating group key as combination of siteId + ruleId
  // to ensure site/rule relationship is maintained when grouping by priority
  return composeInsights(
    groupBy(occurrences, (o) => `${o.siteId} ${o.ruleId}`),
    uniqActionCount
  );
};

export const groupByRule: GroupFunction = (occurrences) => {
  if (occurrences.length < 1) return [];
  return composeInsights(groupBy(occurrences, (o) => o.siteId));
};
